import React from 'react';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconActiveProps, IconRender } from '../types.ts';

const Flash = React.forwardRef<SVGSVGElement | null, IconActiveProps>(function Flash({ active, dataTestId, ...props }, ref) {
  // eslint-disable-next-line no-restricted-syntax
  const iconRender = React.useCallback<IconRender>(
    (color: string) => (
      <>
        {/* default */}
        <path
          d='M18.7453 10.112C18.3816 9.53769 17.6872 9.18077 16.9338 9.18077H13.3628C13.2459 9.18077 13.1726 9.12539 13.1396 9.09257C13.1065 9.05872 13.0545 8.98898 13.0699 8.88744L14.063 2.87936C14.1221 2.52039 13.8859 2.17476 13.495 2.04861C13.1018 1.92143 12.6637 2.05066 12.4393 2.35629L5.32318 12.0617C4.91813 12.6145 4.89215 13.315 5.25469 13.8894C5.61723 14.4637 6.3116 14.8207 7.06619 14.8207H10.6384C10.7553 14.8207 10.8285 14.876 10.8604 14.9089C10.8923 14.9417 10.9466 15.0124 10.9301 15.114L9.94169 21.1221C9.88264 21.481 10.12 21.8267 10.5109 21.9528C10.6113 21.9846 10.7152 22 10.8179 22C11.1131 22 11.3989 21.8708 11.5654 21.6441L18.6768 11.9387C19.0819 11.3859 19.1078 10.6854 18.7453 10.111V10.112Z'
          fill={active ? 'transparent' : color}
        />
        {/* active */}
        <path
          d='M18.7452 10.112C18.3815 9.53769 17.6871 9.18077 16.9337 9.18077H16.9207C16.7881 9.18077 16.6609 9.23345 16.5671 9.32722L11.0072 14.8871C10.95 14.9443 10.943 15.0341 10.93 15.114L9.94161 21.1221C9.88257 21.481 10.1199 21.8267 10.5108 21.9528C10.6112 21.9846 10.7151 22 10.8178 22C11.1131 22 11.3988 21.8708 11.5654 21.6441L18.6767 11.9387C19.0818 11.3859 19.1078 10.6854 18.7452 10.111V10.112Z'
          fill={active ? color : 'transparent'}
        />
        <path
          d='M7.32136 14.8207L4.35348 17.7885C4.15822 17.9838 4.15822 18.3004 4.35348 18.4956L4.70703 18.8492C4.90229 19.0445 5.21888 19.0445 5.41414 18.8492L18.8492 5.41417C19.0444 5.21891 19.0444 4.90232 18.8492 4.70706L18.4956 4.35351C18.3004 4.15825 17.9838 4.15825 17.7885 4.35351L13.1002 9.04181C13.0776 9.00399 13.06 8.95218 13.0698 8.88744L14.063 2.87936C14.122 2.52039 13.8858 2.17476 13.4949 2.04861C13.1017 1.92143 12.6636 2.05066 12.4392 2.35629L5.32311 12.0617C4.91806 12.6145 4.89208 13.315 5.25461 13.8894C5.61715 14.4637 6.31152 14.8207 7.06612 14.8207H7.32136Z'
          fill={active ? color : 'transparent'}
        />
      </>
    ),
    [active],
  );
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'flash-icon-svg'} iconRender={iconRender} {...props} />;
});

export default Flash;
